import { jsx as _jsx } from "react/jsx-runtime";
import { getActiveViewerName, useSession } from '../../../../../../infra/session';
import { useEditableField } from '../../../hooks/use-editable-field';
import { SmsCampaignPreview } from './sms-campaign-preview';
import styles from './styles.module.scss';
import { parseTextWithUrls } from './utils';
export var SmsCampaignPreviewContainer = function (_a) {
    var campaignSmsBody = _a.campaignSmsBody, isLoading = _a.isLoading;
    var session = useSession().data;
    var logoImageField = useEditableField('emailLogoImage').field;
    var name = getActiveViewerName(session);
    var smsBodyParts = parseTextWithUrls(campaignSmsBody);
    return (_jsx("div", { className: styles['content-wrapper'], children: _jsx(SmsCampaignPreview, { logo: logoImageField.value, name: name, smsBodyParts: smsBodyParts, isLoading: isLoading }) }));
};
